module.exports = __webpack_public_path__ + "static/media/The_foods_that_could_prevent_climate_disasters.fab6187f.jpg";